// extracted by mini-css-extract-plugin
export default {"imageItem":"styles_imageItem__CjLhH","containerWithDots":"styles_containerWithDots__sDT+-","dotActive":"styles_dotActive__I-5zl","dotInactive":"styles_dotInactive__TClnK"};